const translations = {
  signIn: "Sign In",
  emailLabel: "Corporation Email",
  emailPlaceholder: "user@arivahly.in",
  passwordLabel: "Password",
  passwordPlaceholder: "••••••••",
  forgotBtn: "Forgot?",
  signInBtn: "Secure Sign In",
  otpBtn: "Sign In with OTP",
  inviteBtn: "Accept Invitation Code",
  resetHeader: "Forgot Password",
  resetPlaceholder: "you@example.com",
  resetBtn: "Send OTP",
  resetOtpHint: "We will send a 6-digit code to your email. Enter it to set a new password.",
  otpCodeLabel: "Verification Code",
  verifyOtpBtn: "Verify Code",
  backToLogin: "Back to login",
  inviteHeader: "Accept Invitation Code",
  inviteCodeLabel: "Authorized Invite Code",
  inviteCodePlaceholder: "Type or paste invite code e.g. INV-XXXX",
  employeeNameLabel: "Employee Full Name",
  employeeNamePlaceholder: "Enter your name",
  employeePhoneLabel: "Employee Mobile No.",
  employeePhonePlaceholder: "+91 XXXXX XXXXX",
  employeePasswordLabel: "Choose Password",
  employeePasswordPlaceholder: "Your secure password",
  registerBtn: "Register Corporate Password",
  publicSignupDisabled:
    "AVS ERP is invitation-only. Request access from AVS, or accept a secure invitation from your jeweller.",
  standardSignInHeader: "Standard Sign In",
  securingSession: "Checking session…",
  productionPortal: "Jewellery ERP · Production Portal",
};

export default translations;
